'use client';
import Link from 'next/link';
import Photo from '@components/elements/Photo';
import { formatPrice } from '@utils/price';
import { formatDuration } from '@lib/duration';
import { fieldImageUrl } from '@lib/hero-field';
import { trackEvent } from '../../../lib/analytics/posthog';
import { EVENTS } from '../../../lib/analytics/events';

/** Dos formas de buscar: por zona (el mapa) y por foto (la vista Trabajos). Sin nombres de negocios. */
export default function SearchWays({ field, works = [] }) {
  const ways = field?.ways;
  return (
    <section className="home-section" aria-labelledby="ways-title">
      <div className="home-wrap">
        <h2 id="ways-title" className="home-title font-display">
          Buscá por zona
          <br className="hidden md:inline" /> o por foto.
        </h2>
        <div className="ways">
          <Link
            href="/negocios"
            className="way way--map"
            onClick={() => trackEvent(EVENTS.HOME_CTA_CLICKED, { cta: 'abrir_mapa', section: 'ways' })}
          >
            {ways && (
              <span className="way__map" aria-hidden="true">
                <img src={fieldImageUrl(ways)} alt="" loading="lazy" decoding="async" />
                <svg viewBox={`0 0 ${ways.width} ${ways.height}`} preserveAspectRatio="xMidYMid slice">
                  <g className="way__dots">
                    {ways.dots.map(([x, y], i) => (
                      <circle key={i} cx={x} cy={y} r={6} />
                    ))}
                  </g>
                </svg>
              </span>
            )}
            <span className="way__text">
              <span className="way__title font-display">En el mapa</span>
              <span className="way__desc">
                <span className="md:hidden">Quién atiende cerca y si tiene turnos hoy.</span>
                <span className="hidden md:inline">Mirá quién atiende cerca, con su precio más bajo y si tiene turnos hoy.</span>
              </span>
            </span>
          </Link>

          <Link
            href="/negocios?vista=trabajos"
            className="way way--works"
            onClick={() => trackEvent(EVENTS.HOME_CTA_CLICKED, { cta: 'ver_trabajos', section: 'ways' })}
          >
            {works.length > 0 && (
              <span className="way__works">
                {works.map((work) => (
                  <span key={work.url} className="way__work">
                    <Photo src={work.url} size={500} alt="" />
                    <span className="work-tag">
                      <b>{work.caption}</b>
                      <span>
                        {formatPrice(work.price)}
                        {work.duration ? <span className="way__dur"> · {formatDuration(work.duration)}</span> : null}
                      </span>
                    </span>
                  </span>
                ))}
              </span>
            )}
            <span className="way__text way__text--solid">
              <span className="way__title font-display">Por trabajo</span>
              <span className="way__desc">
                <span className="md:hidden">Fotos de trabajos con su precio.</span>
                <span className="hidden md:inline">Mirá fotos de trabajos con su precio y llegá a quien lo hizo.</span>
              </span>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
